import { useState, useRef } from "react";
import {
    VStack, Box, Text, HStack, Avatar, Tag, Wrap, WrapItem, Image, Link, Icon,
    Textarea, Flex, Input, Button, useToast,
} from "@chakra-ui/react";
import { FaPaperclip, FaPaperPlane } from "react-icons/fa";
import { criarObsVenda } from "../../services/api";
import { baseUrlApi } from "../../config";
import { formatDateTime } from "../../utils/formatters";

// Fotos dos usuarios (mesmo mapa usado nas demais telas do sistema).
const FOTOS_USUARIO = {
    3: "/gabriel_logo.webp", 4: "/TAGANOBG.png", 5: "/tilio_logo.webp", 6: "/riccioppo_logo.webp",
    7: "/user.png", 8: "/gabriel_valiente_logo.webp", 9: "/emerson_vendedor_logo.webp", 10: "/analuiza_logo.webp",
};
const imgUsuario = (id) => FOTOS_USUARIO[id] || "/user.png";

/**
 * Observacoes de uma venda no padrao unico do sistema (Reclamacoes / Vendas /
 * Despacho): card por autor com avatar, origem, data, anexos e formulario com
 * upload de arquivos. Usa a mesma entidade observacoes_venda (criarObsVenda).
 *
 * props: observacoes[], vendaId, onAdicionado()
 */
export default function ObservacoesVenda({ observacoes, vendaId, onAdicionado }) {
    const toast = useToast();
    const [texto, setTexto] = useState("");
    const [arquivos, setArquivos] = useState([]);
    const [enviando, setEnviando] = useState(false);
    const fileRef = useRef();

    const enviar = async () => {
        if (!texto.trim() && arquivos.length === 0) return;
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        const fd = new FormData();
        fd.append("id", vendaId);
        fd.append("id_user", user.id);
        fd.append("obs", texto);
        arquivos.forEach((f) => fd.append("files[]", f));
        setEnviando(true);
        const res = await criarObsVenda(fd);
        setEnviando(false);
        if (res !== false) {
            setTexto("");
            setArquivos([]);
            if (fileRef.current) fileRef.current.value = "";
            toast({ title: "Observação adicionada", status: "success", duration: 2000, position: "top-right" });
            onAdicionado && onAdicionado();
        } else {
            toast({ title: "Falha ao adicionar observação", status: "error", duration: 4000, position: "top-right" });
        }
    };

    return (
        <VStack align="stretch" spacing={3}>
            {vendaId && (
                <Box bg="white" borderRadius="lg" borderWidth="1px" borderColor="gray.200" p={4}>
                    <Text fontSize="sm" fontWeight="bold" color="gray.700" mb={2}>Adicionar observação</Text>
                    <Textarea value={texto} onChange={(e) => setTexto(e.target.value)} placeholder="Escreva uma observação para esta venda..." size="sm" bg="white" rows={3} />
                    <Flex justify="space-between" align="center" mt={2} wrap="wrap" gap={2}>
                        <Input ref={fileRef} type="file" multiple size="sm" variant="unstyled" fontSize="xs" maxW="240px" onChange={(e) => setArquivos(Array.from(e.target.files))} />
                        <Button size="sm" colorScheme="orange" leftIcon={<FaPaperPlane />} isLoading={enviando} isDisabled={!texto.trim() && arquivos.length === 0} onClick={enviar}>Adicionar</Button>
                    </Flex>
                </Box>
            )}
            {(!observacoes || observacoes.length === 0) && (
                <Box bg="white" borderRadius="lg" borderWidth="1px" borderColor="gray.200" p={6} textAlign="center">
                    <Text color="gray.400" fontSize="sm">Nenhuma observação registrada nesta venda.</Text>
                </Box>
            )}
            {(observacoes || []).map((o) => (
                <Box key={o.id} bg="white" borderRadius="lg" borderWidth="1px" borderColor="gray.200" p={4}>
                    <HStack justify="space-between" mb={2} wrap="wrap">
                        <HStack spacing={2}>
                            <Avatar size="xs" name={o.usuario?.name} src={imgUsuario(o.usuario?.id)} />
                            <Text fontSize="sm" fontWeight="bold" color="gray.700">{o.usuario?.name || "Sistema"}</Text>
                            {o.origem && <Tag size="sm" colorScheme="gray" variant="subtle">{o.origem}</Tag>}
                        </HStack>
                        <Text fontSize="11px" color="gray.400">{o.created_at ? formatDateTime(o.created_at) : ""}</Text>
                    </HStack>
                    <Text fontSize="sm" whiteSpace="pre-wrap" color="gray.800">{o.observacao}</Text>
                    {(o.arquivos || []).length > 0 && (
                        <Wrap mt={3} spacing={2}>
                            {o.arquivos.map((a) => {
                                const url = baseUrlApi.replace("api", "") + "storage/" + a.file_path;
                                const ehImg = /\.(jpe?g|png|gif|webp)$/i.test(a.file_path || "");
                                return (
                                    <WrapItem key={a.id}>
                                        {ehImg
                                            ? <Image src={url} alt={a.file_name || "anexo"} boxSize="80px" objectFit="cover" borderRadius="md" borderWidth="1px" borderColor="gray.200" cursor="pointer" onClick={() => window.open(url, "_blank")} />
                                            : <Link href={url} isExternal fontSize="11px" color="blue.500" display="inline-flex" alignItems="center"><Icon as={FaPaperclip} mr={1} boxSize={2.5} />{a.file_name || "arquivo"}</Link>}
                                    </WrapItem>
                                );
                            })}
                        </Wrap>
                    )}
                </Box>
            ))}
        </VStack>
    );
}
